export const TranslationsSK = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        sk: 'Slovenčina',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
        hi: 'हिन्दी',
        ko: '한국어',
        ru: 'Русский',
        tr: 'Türkçe',
        nl: 'Nederlands',
        pl: 'Polski',
        ms: 'Bahasa Melayu',
        ro: 'Română',
        cs: 'Čeština',
        hu: 'Magyar',
        ta: 'தமிழ்',
        te: 'తెలుగు',
        bn: 'বাংলা',
        zht: '繁體中文',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        sk: 'SK',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
        hi: 'HI',
        ko: 'KO',
        ru: 'RU',
        tr: 'TR',
        nl: 'NL',
        pl: 'PL',
        ms: 'MS',
        ro: 'RO',
        cs: 'CS',
        hu: 'HU',
        ta: 'TA',
        te: 'TE',
        bn: 'BN',
        zht: 'ZHT',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        sk: 'SLK',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
        hi: 'HIN',
        ko: 'KOR',
        ru: 'RUS',
        tr: 'TUR',
        nl: 'NLD',
        pl: 'POL',
        ms: 'MSA',
        ro: 'RON',
        cs: 'CES',
        hu: 'HUN',
        ta: 'TAM',
        te: 'TEL',
        bn: 'BEN',
        zht: '繁體',
    },
    // BASE
    phrases: {
        order_online: 'Objednať online',
        cart: 'Košík',
        open_24: '24 hodín',
        closed: 'ZATVORENÉ',
        free: 'ZDARMA',
        something_went_wrong: 'niečo sa pokazilo',
        try_again: 'skúste to znova',
    },
    constants: {
        calendar: {
            days: {
                monday: 'pondelok',
                tuesday: 'utorok',
                wednesday: 'streda',
                thursday: 'štvrtok',
                friday: 'piatok',
                saturday: 'sobota',
                sunday: 'nedeľa',
            },
        },
        services: {
            pickup: 'Vyzdvihnutie',
            delivery: 'Doručenie',
            dine_in: 'Konzumácia na mieste',
            table_booking: 'Rezervácia stola',
        },
        payment: {
            method: {
                cash: 'Hotovosť',
                card: 'Karta',
                stripe: 'Kreditná karta',
                paypal: 'PayPal',
                cardconnect: 'Kreditná karta',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                razor_pay: 'Razor Pay',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                custom: 'Vlastné',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                authorized: 'Authorize.net'
            },
            // BACKENDMETHODNAMES
            backend_method: {
                cash: 'Cash',
                card: 'Card',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                bambora_na: 'Worldline',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                stripe_digital_wallet: 'Google/Apple Pay',
                razor_pay: 'Razor Pay',
                gravity: 'Gravity',
                authorized: 'Authorize.net',
                elavon: 'Elavon',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                custom: 'Custom',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                nuvei: 'Nuvei',
                ONLINE: 'Online',
                online: 'Online'
            },
            status: {
                success: 'Úspech',
                pending: 'Čaká na spracovanie',
                error: 'Chyba',
                refunded: 'Vrátené',
                refunding: 'Vrátenie peňazí',
                partial_refunded: 'Čiastočne vrátené',
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: 'Odstrániť',
                drop_here: 'Sem presuňte svoje súbory alebo kliknutím vyberte jeden',
                accepts: 'Prijíma {{fileTypes}} súbory',
                errors: {
                    max_files: 'Maximálny povolený počet je {{number}}',
                    max_size: 'Maximálna veľkosť súboru {{kilobytes}} kB',
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: 'Prevádzka je momentálne zatvorená, preto nie je možné zadať objednávku na konzumáciu na mieste s okamžitým termínom. Môžete skúsiť objednať na neskorší dátum a čas',
            },
            buttons: {
                order: {
                    book_order: 'Rezervovať stôl / objednať online',
                    order_online: 'Objednať online',
                    book_table: 'Rezervovať stôl',
                    order: 'Objednať',
                    book: 'Rezervovať',
                    cart: 'Košík',
                    restart: 'Začať znova',
                    closed: 'Prevádzka je zatvorená',
                    not_accepting: 'Objednávky sa neprijímajú',
                },
            },
        },
        modals: {
            auth: {
                login: 'Prihláste sa',
                register: 'Zaregistrujte sa',
                register_commence: 'Pokračovať',
                register_complete: 'Vytvoriť účet',
                register_confirmation_sent: 'Potvrdzovací kód bol odoslaný na vašu e-mailovú adresu. Ak chcete pokračovať, zadajte ho nižšie',
                register_confirmation_resent: 'Potvrdzovací kód bol odoslaný znova, skontrolujte svoj spam alebo reštartujte proces',
                register_restart: 'Začať znova',
                register_resend_code: 'Znova odošlite kód',
                register_confirmation_code_subject: 'E-mailový potvrdzovací kód',
                register_confirmation_code_email: 'Váš potvrdzovací kód e-mailu je {{confirmation_code}} (platnosť vyprší o 24 hodín)',
                login_placeholder: 'E-mail',
                password_placeholder: 'heslo',
                confirm_password_placeholder: 'Potvrďte heslo',
                confirmation_code_placeholder: 'E-mailový potvrdzovací kód',
                accept_terms: 'Prijmite zmluvné podmienky',
                accept_terms_view: 'Zobraziť',
                login_facebook: 'Prihlásiť sa cez Facebook',
                login_google: 'Prihlásiť sa cez Google',
                benefits: 'Prihláste sa alebo si vytvorte účet a uložte si všetky svoje objednávky',
                logged_in: 'Úspešne prihlásení',
                logged_out: 'Odhlásený',
                password_reset: {
                    init_button: 'Odoslať e-mail na obnovenie hesla',
                    init_success: 'Odkaz na obnovenie hesla bol odoslaný na váš e-mail',
                    complete_button: 'Obnoviť heslo',
                    complete_success: 'Heslo bolo úspešne resetované, prihláste sa pomocou nového hesla',
                    forgot_password_text: 'Zabudli ste heslo?',
                    forgot_password_link: 'Obnoviť heslo',
                    remember_password_text: 'Pamätáte si svoje heslo?',
                    remember_password_link: 'Späť',
                    invalid_title: 'Obnovenie hesla je neplatné',
                    invalid_description: 'Tento odkaz na obnovenie hesla nie je platný, požiadajte namiesto toho o nové',
                    invalid_link: 'Prejsť na Prihlásenie',
                    title: 'Obnovenie hesla',
                    description: 'Zadajte nové heslo pre svoj účet',
                },
                error_generic: 'Vyskytol sa problém, skúste to znova alebo nás kontaktujte',
                error_accept_terms: 'Prijmite prosím zmluvné podmienky',
                error_password_length: 'Minimálne 6 znakov pre heslo',
                error_social: 'Vyskytol sa problém, skúste to znova alebo nás kontaktujte',
                error_confirmation_code: 'Neplatný potvrdzovací kód',
                error_invalid_code: 'Neplatný potvrdzovací kód',
                error_exists: 'Používateľ už existuje',
                error_invalid_email_pass: 'Neplatná e-mailová adresa alebo heslo',
                error_password_no_match: 'Heslá sa navzájom nezhodujú',
                error_user_not_found: 'Žiadny používateľ s touto e-mailovou adresou',
                error_invalid_email: 'Neplatná e-mailová adresa',
                error_invalid_reset_token: 'Neplatný odkaz na obnovenie, vyžiadajte si iný',
            },
            booking: {
                form: {
                    name: 'Celé meno',
                    email: 'E-mailová adresa',
                    phone: 'Telefónne číslo',
                    number_of_people: 'Počet ľudí',
                    number_of_people_max: 'Počet ľudí (max. {{max_people}})',
                    number_of_people_min: 'Počet ľudí (min. {{min_people}})',
                    number_of_people_max_min: 'Počet ľudí (od {{min_people}} do {{max_people}})',
                    notes: 'Poznámky / špeciálne požiadavky',
                    submit: 'Odoslať požiadavku na rezerváciu',
                    email_optional: '(voliteľné)',
                    date: 'Dátum',
                    duration: 'Trvanie',
                    seating: 'Dostupné časy',
                    number_of_guests: 'Počet hostí',
                    notes_placeholder: 'Alergie, príležitosť, preferencia miesta',
                    reserving: 'Rezervujem...',
                    reserve_table: 'Rezervovať stôl',
                    please_choose_a_date_and_time: 'Vyberte dátum a čas.',
                    invalid_people: 'Počet osôb musí byť medzi {{min}} a {{max}}.',
                    party_size_max_fallback: 'povolené maximum',
                    loading_available_times: 'Načítavajú sa dostupné časy…',
                    select_a_date_to_see_available_times: 'Vyberte dátum, aby ste videli dostupné časy.',
                    no_times_available_for_this_date: 'Pre tento dátum nie sú dostupné žiadne časy. Vyberte iný deň.',
                    shift: 'Zmena',
                    service_times: 'Prevádzkové hodiny',
                    new_shift: 'Nová zmena',
                    time: 'čas',
                    times: 'časy',
                    unavailable: 'Nedostupné',
                    available: 'Dostupné',
                    required_name: 'Zadajte svoje meno.',
                    required_phone: 'Zadajte svoje telefónne číslo.',
                    required_email: 'Zadajte svoju e-mailovú adresu.',
                    invalid_email: 'Zadajte platnú e-mailovú adresu.',
                    required_terms: 'Pred rezerváciou prijmite podmienky.',
                    reservation_is_unavailable: 'Rezervácia nie je k dispozícii.',
                    please_contact_the_restaurant_directly: 'Kontaktujte reštauráciu priamo.',
                    almost_done: 'Takmer hotovo',
                    your_details: 'Vaše údaje',
                    tell_us_who_s_coming: 'Povedzte nám, kto príde, aby sme mohli potvrdiť vašu rezerváciu.',
                    book_your_table: 'Rezervujte si stôl',
                    choose_a_time_that_works_for_you: 'Vyberte čas, ktorý vám vyhovuje.',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: 'Odošlite žiadosť o rezerváciu a reštaurácia sa postará o zvyšok.',
                    select_date: 'Vybrať dátum',
                    standard: 'Štandard',
                    minutes: 'minút',
                    next: 'Ďalej →',
                    back: '← Späť',
                    accept_terms: 'Súhlasím s podmienkami.',
                    info_1: 'Keď bude vaša rezervácia prijatá alebo zamietnutá, dostanete e-mailové upozornenie',
                },
                errors: {
                    not_found: "Rezervácia neexistuje. Pravdepodobne bola odstránená",
                    generic: 'Vyskytol sa problém, obnovte stránku alebo nás kontaktujte',
                    something_went_wrong: 'Niečo sa pokazilo',
                    accept_terms: 'Prijmite prosím zmluvné podmienky',
                    required_phone: 'Zadajte svoje telefónne číslo',
                    required_email: 'Zadajte svoj email',
                    required_zip: 'Zadajte PSČ fakturácie',
                    required_name: 'Zadajte svoje meno',
                    invalid_email: 'Zadajte platnú e-mailovú adresu',
                    invalid_phone: 'Zadajte platné telefónne číslo',
                    invalid_people: 'Neplatný počet osôb',
                    missing_custom_fields: 'Vyplňte všetky povinné polia.',
                    booking_capacity_threshold: 'Na tento čas sme plne obsadení. Skúste iný čas.',
                    slot_unavailable: 'Pre tento počet osôb sme plne obsadení. Skúste iný čas.',
                    booking_date_paused: 'Rezervácie na tento dátum sú pozastavené. Vyberte iný deň.',
                    invalid_table_assignment: 'Tieto stoly nepojmú vašu skupinu. Vyberte iný čas.',
                    exceeded_order_limit: 'Príliš veľa žiadostí o rezerváciu. Skúste to neskôr.',
                    validation_failed_recaptcha_v3: 'Zistená neobvyklá prevádzka. Používate VPN? Dokončite overenie vyššie a skúste to znova.',
                    validation_failed_recaptcha_v2: 'Rezerváciu sa nepodarilo spustiť. Skúste to znova alebo použite iný spôsob. Ak používate VPN, skúste ju najprv vypnúť.',
                    booking_already_exists: 'Táto rezervácia už bola odoslaná. Skontrolujte e-mail alebo otvorte odkaz na rezerváciu.',
                    invalid_party_size: 'Vyberte platný počet osôb.',
                    invalid_request: 'Neplatná požiadavka. Obnovte stránku a skúste to znova.',
                    table_booking_unavailable: 'Rezervácia stola nie je k dispozícii.',
                },
            },
            cart: {
                title: 'Košík',
                proceed_to_checkout: 'Pokračujte k pokladni',
                edit_dish: 'Upraviť',
                remove_dish: 'Odstrániť',
                no_items_1: 'Žiadne položky v košíku',
                no_items_2: 'Ak chcete pokračovať, najprv pridajte nejaké',
                free_delivery_notice: 'Bezplatné doručenie pre objednávky nad {{value, currency}}',
                errors: {
                    min_order_promo: 'Na uplatnenie tejto promo akcie je potrebná minimálna hodnota košíka {{value, currency}}',
                    min_order_delivery: 'Minimálna hodnota košíka {{value, currency}} na doručenie',
                },
                promo: {
                    heading: 'Promo kód',
                    placeholder: 'Zadajte promo kód',
                    add: 'Pridať kód',
                    title: 'Promo {{name}} pridané do košíka',
                    fixed_discount: 'Zľava {{value, currency}}',
                    percent_discount: 'Zľava {{value}}%',
                    added_to_cart: 'Promo bolo pridané do košíka',
                    errors: {
                        not_found: 'Promo sa nenašlo',
                        disabled: 'Promo akcia je vypnutá',
                        not_available: 'Akcia momentálne nie je k dispozícii',
                        not_eligible: 'Tento promo kód nemôžete použiť',
                        not_available_time: 'Akcia tentokrát neplatí',
                        logged_in_only: 'Ak chcete použiť túto akciu, musíte sa prihlásiť',
                        already_used: 'Túto akciu ste už využili',
                        invalid: 'Táto akcia už nie je platná',
                        invalid_service: 'Táto akcia neplatí pre vami vybranú službu',
                        later_only: 'Platí len pre predobjednávky',
                        now_only: 'Platí len pre objednávky s okamžitou platnosťou, nie pre predobjednávky',
                        generic: 'Ups... niečo sa pokazilo a chyba bola zaznamenaná',
                        dishes_required_multi: 'Táto akcia sa uplatní len vtedy, keď do košíka pridáte určité položky',
                        dishes_required_single: "Toto promo sa bude vzťahovať iba na '{{dish}}'",
                    },
                },
                tip: {
                    title: 'Prepitné',
                    placeholder: 'Pridať prepitné',
                },
            },
            free_items_promo: {
                title: 'Položky zadarmo',
                usage_confirmation: {
                    question: 'Máte nárok na bezplatné položky. Chceli by ste ich vidieť a pridať?',
                    cancellation: "Nie, nechcem položky zadarmo",
                    acceptance: 'áno',
                },
                free_items_selection: {
                    multiple: {
                        description: 'Vyberte položky zdarma ({{number}})',
                    },
                    single: {
                        description: 'Vyberte si bezplatnú položku',
                    },
                    confirm_button: 'Potvrďte',
                },
            },
            checkout: {
                title: 'Dokončenie objednávky',
                subtitle: 'Potvrďte podrobnosti objednávky',
                details: {
                    service: 'Služba',
                    due: 'Termín',
                    due_now_asap: 'Teraz / ASAP',
                    address: 'Dodacia adresa',
                    total: 'Celkom',
                    table: 'Stôl',
                    store_location: 'Adresa prevádzky',
                },
                customer: {
                    title: 'Zákazník',
                    subtitle: 'Prihláste sa pre uloženie objednávky a podrobností',
                    button: 'Prihláste sa',
                    name: 'Celé meno',
                    email: 'Email',
                    phone: 'Telefón',
                    phone_important: 'Telefón (dôležité)',
                    notes: 'Poznámky k objednávke',
                    delivery_notes: 'Dodacie pokyny / poznámky k objednávke',
                    uber_delivery_notes_too_long: 'Pokyny na doručenie môžu mať najviac {{max}} znakov.',
                    uber_delivery_notes_near_limit: 'Dosiahli ste limit počtu znakov {{max}}. Ak chcete zadať objednávku, skráťte svoje poznámky.',
                    optional: 'voliteľné',
                },
                payment: {
                    title: 'Spôsob platby',
                    qr_modal_help: 'Pomocou mobilnej aplikácie {{app}} naskenujte QR kód a dokončite platbu za túto objednávku. Po dokončení platby vo vašej mobilnej aplikácii môžete tento QR modal zatvoriť. Ak ste nedokončili proces platby, nezatvárajte tento kód QR.',
                    switch_to_app_help: 'Stlačením tlačidla nižšie sa automaticky otvorí mobilná aplikácia {{app}} na dokončenie platby za túto objednávku. Po dokončení platby vo vašej mobilnej aplikácii môžete tento spôsob zatvoriť. Ak ste nedokončili proces platby, nezatvárajte tento spôsob platby.',
                    open_app: 'Otvorte aplikáciu {{app}}',
                    continue: 'Pokračovať',
                    continue_to_payment: 'Pokračovať na {{method}}',
                    back_to_cart: 'Späť do košíka',
                },
                accept_terms: 'Prijmite zmluvné podmienky',
                accept_terms_view: 'Zobraziť',
                processing_order: 'Spracovanie objednávky',
                warning: {
                    different_payment_currency: 'Ceny prevádzky sú v mene {{store_currency}}, ale spôsob platby používa menu {{payment_currency}}',
                    closing_soon: 'Čoskoro sa zatvára, objednávky musia byť zadané do {{value}} minút',
                    closed: 'Ľutujeme, táto služba je zatvorená a objednávky neprijímame',
                    paused: 'Ľutujeme, táto služba bola pozastavená a objednávky sa momentálne neprijímajú',
                    expired: 'Vašu objednávku už nemôžeme splniť vo vami zvolenom čase. Vyberte neskorší dátum alebo čas',
                },
                errors: {
                    walletly_promo: 'Walletly promo má chybu, skúste prosím inú!',
                    stripe_generic: 'Chyba kreditnej karty, skúste to znova alebo inou metódou',
                    validation_failed: 'Túto platbu momentálne nemožno akceptovať. Skúste to znova neskôr alebo vyberte iný spôsob platby.',
                    validation_failed_recaptcha_v3: 'Bola zistená nezvyčajná premávka. Používate VPN? Dokončite vyššie uvedenú výzvu a skúste to znova.',
                    validation_failed_recaptcha_v2: 'Nepodarilo sa nám spustiť platbu. Skúste to znova alebo použite inú metódu. Ak používate sieť VPN, skúste ju najskôr vypnúť.',
                    stripe_loading_fail: 'Chyba pri načítavaní platobného formulára, skúste to znova',
                    something_went_wrong: 'Niečo sa pokazilo',
                    paypal_generic: 'Vyskytol sa problém s PayPal, skúste to znova alebo vyberte iný spôsob platby',
                    payment_fail: 'Platba zlyhala, skúste to znova alebo vyberte iný spôsob platby',
                    payment_cancelled: 'Platba bola zrušená, skúste to znova alebo vyberte iný spôsob platby',
                    payment_error: 'Pri spracovaní online platby sa vyskytla chyba, skúste to znova alebo vyberte iný spôsob platby',
                    payment_declined: 'Váš spôsob platby bol odmietnutý',
                    card_declined: "Vaša karta bola odmietnutá a platbu nebolo možné spracovať",
                    promo_max_uses_exceeded: "Ovaj promo kod je dostigao ograničenje korišćenja i više nije dostupan.",
                    store_closed: 'Prevádzka je zatvorená a už neprijíma objednávky',
                    accept_terms: 'Prijmite prosím zmluvné podmienky',
                    required_payment: 'Vyberte spôsob platby',
                    required_phone: 'Zadajte svoje telefónne číslo',
                    required_email: 'Zadajte svoj email',
                    required_zip: 'Zadajte PSČ fakturácie',
                    required_name: 'Zadajte svoje meno',
                    invalid_email: 'Zadajte platnú e-mailovú adresu',
                    invalid_phone: 'Zadajte platné telefónne číslo',
                    invalid_cc_number: 'Číslo vašej kreditnej karty je neplatné',
                    invalid_order_amount: 'Minimálna suma požadovaná pre tento spôsob platby',
                    retry_cc_number: 'Niečo sa pokazilo, znova zadajte číslo kreditnej karty a skúste to znova',
                    closed: 'Prevádzka je zatvorená a neprijíma objednávky',
                    promo_login_required: 'Ak chcete použiť túto akciu, musíte sa prihlásiť',
                    promo_used: 'Túto akciu ste už využili',
                    promo_by_payment_method_not_applicable: 'Akcia sa nevzťahuje na vybraný spôsob platby.',
                    missing_custom_checkout_fields: 'Vyplňte všetky povinné polia.',
                    delivery_unavailable: 'Doručovacia služba nemusí byť momentálne k dispozícii. Zvážte namiesto toho objednávku na vyzdvihnutie.',
                    required_delivery_provider: 'Vyberte si službu doručenia.',
                    required_delivery_quotation: 'Platnosť odhadu doručenia vypršala.',
                    exceeded_order_limit: 'Momentálne dostávame veľa objednávok. Vyberte neskorší čas.',
                    exceeded_order_limit_later: 'Vašu objednávku už nemôžeme splniť vo vami zvolenom čase. Vyberte neskorší dátum alebo čas',
                },
                button: {
                    continue: 'Pokračovať na platbu',
                    place_order: 'Zadať objednávku',
                    update_order: 'Aktualizovať objednávku',
                },
                delivery_estimation: {
                    title: 'Odhad doručenia',
                    details: {
                        provider: 'Poskytovateľ doručenia',
                        estimated_fee: 'Odhadovaný poplatok',
                        estimated_total_fee: 'Poplatok za doručenie celkom',
                        estimated_discount_fee: 'Zľava z poplatku za doručenie',
                        previous_estimated_fee: 'Predchádzajúci odhadovaný poplatok',
                        tips: 'Prepitné',
                        estimated_delivery_time: 'Odhadovaný čas doručenia',
                        uber_new_estimation: 'Požiadať o nový odhad',
                        uber_new_estimation_success: 'Bol použitý nový odhad doručenia Uber.',
                        uber_estimation_expired: 'Platnosť odhadu doručenia vypršala',
                        uber_price: 'Držíme cenu Uber',
                        uber_need_time: 'Potrebujem viac času',
                        uber_delivery_notes_too_long: 'Pokyny na doručenie môžu mať najviac {{max}} znakov, ak chcete požiadať o doručenie Uber.',
                        lalamove_price: 'Držíme poplatok za doručenie Lalamove',
                        lalamove_new_estimation_success: 'Použil sa nový odhad doručenia Lalalmove.',
                        lalamove_estimation_expired: 'Platnosť odhadu doručenia vypršala',
                        lalamove_need_time: 'Potrebujem viac času',
                        lalamove_new_estimation: 'Požiadať o nový odhad',
                    },
                    quotation_error: 'Pri výpočte odhadu doručenia sa vyskytla chyba.',
                },
            },
            customer: {
                age_v: {
                    title: 'Overenie veku',
                    required_for_items: 'Vyžaduje sa na objednanie určitých položiek',
                    min_age: 'Minimálny vek: {{age}} rokov',
                    est_time: 'Odhadovaný čas overenia: {{time}} hodín',
                    upload_description: 'Nižšie nahrajte svoje ID na overenie. Po overení budete informovaní e-mailom. Nahrajte až 2 obrázky s maximálnou veľkosťou 2 MB',
                    pending_description_1: 'Ďakujeme za odoslanie dokumentov. O schválení budete informovaní e-mailom',
                    pending_description_2: 'Ak chcete aktualizovať stav overenia, obnovte stránku. Odhadovaný čas overenia je {{time}} hodín',
                    approved_description: 'Váš účet bol overený a môžete objednávať z obmedzených ponúk',
                    rejected_description: 'Váš doklad totožnosti bol odmietnutý. Ak to chcete skúsiť znova, znova nahrajte svoje ID',
                    upload: 'Nahrať',
                    reupload: 'Znova nahrajte dokumenty',
                    go_back: 'Späť',
                    view_document: 'Zobraziť dokument {{number}}',
                    status: {
                        unverified: 'Neoverené',
                        pending: 'Čaká sa na schválenie',
                        approved: 'Úspešne overené',
                        rejected: 'Odmietnuté',
                    },
                },
                headings: {
                    sessions: 'Relácie',
                    orders: 'Objednávky',
                    spend: 'Útrata',
                    order_history: 'História objednávok',
                    loyalty: 'Vernosť',
                    loyalty_points: 'Vernostné body',
                    added: 'Promo bolo pridané.',
                },
                loyalty_errors: {
                    invalid_cart_items: 'Pred uplatnením vyberte ľubovoľnú položku!',
                    not_found: 'Akcia nebola nájdená!',
                    already_exists: 'Promo už existuje!',
                    try_again: 'Túto ponuku nie je možné uplatniť. Skúste to znova!',
                },
            },
            custom_payment: {
                title: 'Platobný formulár {{name}}',
                description: 'Dostali ste sa na náš online platobný formulár. Ak chcete uskutočniť platbu, vyplňte polia nižšie. Ak nezadáte sumu, vaše údaje sa uložia, ale nebudú vám účtované.',
                disabled: 'Táto online platobná stránka nebola správne nakonfigurovaná. Ak chcete problém vyriešiť, kontaktujte vlastníka lokality.',
                success: 'Vaša platba bola úspešne spracovaná a vaše údaje boli uložené. Ďakujeme',
                back: 'Späť na domovskú stránku',
                fields: {
                    name: 'Celé meno',
                    email: 'E-mailová adresa',
                    reference: 'Referencia platby',
                    amount: 'Suma ($)',
                    name_on_card: 'Meno na karte',
                    submit: 'Odoslať platbu',
                },
                warning: {
                    currency: 'Poznámka: Suma platby v {{actual}}, nie {{default}}',
                },
                errors: {
                    generic: 'Vyskytol sa problém, skúste to znova alebo nás kontaktujte',
                    stripe_generic: 'Chyba kreditnej karty, obnovte stránku a skúste to znova',
                    payment_fail: 'Platba zlyhala, skúste to znova alebo vyberte iný spôsob platby',
                    payment_cancelled: 'Platba bola zrušená, skúste to znova alebo vyberte iný spôsob platby',
                    payment_error: 'Pri spracovaní online platby sa vyskytla chyba, skúste to znova alebo vyberte iný spôsob platby',
                    payment_declined: 'Váš spôsob platby bol odmietnutý',
                    card_declined: "Vaša karta bola odmietnutá a platbu nebolo možné spracovať",
                    promo_max_uses_exceeded: "Ovaj promo kod je dostigao ograničenje korišćenja i više nije dostupan.",
                },
            },
            dish: {
                add: 'Pridať do košíka',
                edit: 'Aktualizovať položku',
                notes: 'Špeciálne pokyny...',
                ingredients: {
                    title: 'Ingrediencie',
                    uncheck_remove: 'Ak chcete odstrániť, zrušte začiarknutie',
                },
                ingredients_title: 'Ingrediencie',
                combo: {
                    choose_dish: 'Vyberte položku',
                },
                option_sets: {
                    conditions: {
                        select_one: 'Vyberte jednu (povinné)',
                        select_one_optional: 'Vyberte jednu (voliteľné)',
                        select_between: 'Vyberte si medzi {{min}} – {{max}} (povinné)',
                        select_at_least: 'Vyberte aspoň {{qty}} (povinné)',
                        select_up_to: 'Vyberte až {{qty}} (voliteľné)',
                        select_multiple_optional: 'Vybrať viacero (voliteľné)',
                        select_multiple: 'Vybrať viacero (povinné)',
                        free_amount: 'Prvých {{qty}} zadarmo / {{selected}} vybraných',
                    },
                    points: {
                        none_consumed: 'Môžete si zadarmo vybrať maximálne {{maxFree}} možností',
                        less_than_total_points: 'Môžete si bezplatne vybrať viac možností',
                        greather_than_total_points: 'Môžete si vybrať viac možností za príplatok',
                    },
                },
                error: 'Opravte všetky možnosti označené červenou farbou',
                added_to_cart: 'Položka bola pridaná do košíka',
            },
            map: {
                zone_fee: 'Poplatok za doručenie',
                view_in_google: 'Zobraziť v Google Maps',
            },
            portal_go_back: {
                title: 'Prejsť späť na vyhľadávanie reštaurácií?',
                description: 'Všetky položky vo vašom košíku sa stratia',
                cancel: 'Zrušiť',
                proceed: 'Choď späť',
            },
            order: {
                config: {
                    services: {
                        title: 'Vyberte službu',
                        table_booking: 'Rezervovať stôl',
                    },
                    address_custom: {
                        input_placeholder: 'Zadajte svoju adresu',
                    },
                    address: {
                        input_placeholder: 'Nájdite svoju dodaciu adresu',
                        extras_placeholder: 'Číslo jednotky, názov budovy, pokyny na dodanie atď...',
                        search_placeholder: 'Vyhľadajte svoju adresu',
                        search_input_placeholder: 'Ak chcete hľadať, zadajte',
                        no_address_found: 'Nenašli sa žiadne adresy. Skúste zadať viac ako 5 znakov',
                        not_found: 'Dodacia adresa nebola nájdená alebo platná, skúste to znova',
                        not_delivering: 'Na túto adresu momentálne nedoručujeme',
                        not_in_range: 'Vaša adresa nie je v dosahu našej predajne',
                        not_in_zone: 'Vaša adresa sa nenachádza v aktívnej doručovacej zóne',
                        no_number: 'Vaša adresa musí obsahovať číslo ulice',
                        location_permission: 'Povoliť tejto webovej lokalite prístup k vašej aktuálnej polohe?',
                        location_permission_warning: "Nedá sa získať prístup k vašej aktuálnej polohe. Povoľte službu určovania polohy na svojom zariadení a webovom prehliadači. Tu sú niektoré referencie:",
                        pick_location: 'Vyberte si svoju polohu',
                        pick_location_help_text: 'Potiahnutím značky vyberte polohu na mape.',
                        use_current_location: 'Použiť aktuálnu polohu',
                        locate_on_map: 'Nájdite na mape',
                    },
                    datetime: {
                        title: 'Kedy by ste chceli svoju objednávku',
                        due_now: 'Teraz',
                        due_later: 'Neskôr',
                        service_not_available: 'Ľutujeme, momentálne neprijímame objednávky na {{service}}',
                        currently_closed: '{{service}} je momentálne zatvorená, ale môžete si ju objednať neskôr',
                        due_unavailable: 'nedostupné',
                        due_closed: 'ZATVORENÉ',
                        select_date: 'Vyberte dátum',
                        select_time: 'Vyberte čas',
                        select_order_date: 'Vyberte dátum objednávky',
                        select_order_time: 'Vyberte čas objednávky',
                        select_order_date_time: 'Vyberte dátum/čas vašej objednávky',
                        select_booking_date: 'Vyberte dátum rezervácie',
                        select_booking_time: 'Vyberte čas rezervácie',
                        no_times_available: 'Nie sú k dispozícii žiadne časy na výber',
                        date_today: '(dnes)',
                        date_closed: '(ZATVORENÉ)',
                        date_bookings_paused: '(Rezervácie pozastavené)',
                        time_slot_closed: 'ZATVORENÉ',
                    },
                    number_of_people: {
                        placeholder: 'Počet ľudí',
                    },
                    table: {
                        select: 'Vyberte stôl',
                        select_popup_title: 'Vyberte svoj stôl',
                        password: 'Heslo stola',
                        password_warning: 'Ak chcete pokračovať, zadajte heslo vášho stola',
                    },
                    warning: {
                        closed: 'Ľutujeme, momentálne máme zatvorené / neprijímame žiadne objednávky',
                        not_available: 'Ľutujeme, momentálne neprijímame žiadne objednávky',
                    },
                    eta: {
                        delivery: `Odhadovaný čas doručenia je približne {{minutesToCustomer}} minút`,
                        pickup: `Objednávka bude pripravená za približne {{minutesToCustomer}} minút`,
                    },
                    start_button: 'Začať objednávku',
                },
                history: {
                    invalid: 'Nie je možné znovu objednať, pretože niektoré z objednaných položiek boli upravené alebo už nie sú k dispozícii',
                },
                reorder: {
                    title: 'Rýchla opätovná objednávka',
                    description: 'Jednoducho si objednajte položky z predchádzajúcich objednávok',
                },
            },
            receipt: {
                errors: {
                    not_found: 'Objednávka sa nenašla, obnovte stránku a skúste to znova',
                    booking_not_found: 'Rezervácia neexistuje. Možno bola odstránená',
                    generic: 'Vyskytol sa problém, obnovte stránku alebo nás kontaktujte',
                },
                connection: {
                    connected: 'Aktualizácie v reálnom čase',
                    connecting: 'Pripojenie aktualizácií v reálnom čase',
                    disconnected: 'Aktualizácie v reálnom čase sú odpojené',
                },
            },
            warnings: {
                logout: {
                    pretitle: 'POZOR',
                    title: 'Odhlásiť sa',
                    body: 'Odhlásením sa odstránia všetky položky, ktoré boli pridané do košíka',
                    cancel: 'Zrušiť',
                    proceed: 'Pokračujte',
                },
                order_restart: {
                    warning: 'POZOR',
                    title: 'Zmeniť podrobnosti objednávky',
                    body: 'Zmenou podrobností objednávky odstránite položky z košíka, pretože niektoré položky môžu byť nedostupné',
                    cancel: 'Zrušiť',
                    proceed: 'Pokračujte',
                },
                order_expired: {
                    subtitle: 'Dôležité',
                    title: 'Objednávka zmenená na okamžitú',
                    description: 'Čas vybraný pre vašu objednávku sa blíži. Objednávka bola preto zmenená na okamžitú / čo najskôr',
                    button: 'Dobre',
                },
                order_expiring: {
                    subtitle: 'Dôležité',
                    title: 'Termín objednávky čoskoro vyprší',
                    description: 'Vaša objednávka musí byť zadaná do {{time, timeFromTimestamp}}, inak už nebude platná',
                    button: 'Dobre',
                },
                location_permission: {
                    cancel: 'Zrušiť',
                    proceed: 'Pokračujte',
                },
            },
            card_payment_authentication: {
                title: 'Overenie platby',
                note: 'Toto okno nechajte otvorené, kým nedokončíte proces overenia z vašej banky.',
            },
            maps: {
                cancel: 'Zrušiť',
                use_location: 'Použiť polohu',
            },
            app_refresh: {
                refresh: 'Obnoviť',
                title: 'Obnoviť prevádzku',
                description: 'Naša prevádzka bola aktualizovaná. Obnovte prehliadač, aby ste získali najnovšiu verziu. Po obnovení možno budete musieť znova otvoriť košík a pokračovať v dokončení objednávky.',
            },
        },
        sections: {
            nav_top: {
                guest: 'hosť',
                login: 'Prihláste sa',
                login_signup: 'Prihláste sa / Zaregistrujte sa',
                logout: 'Odhlásiť sa',
            },
            menus: {
                info: {
                    no_menus: 'Momentálne nie sú k dispozícii žiadne ponuky',
                    restrictions: 'Obmedzenia ponuky',
                    not_available: 'Ponuka nie je k dispozícii',
                    unavailable: {
                        times: "Menu nie je k dispozícii, vaše požiadavky na objednávku sa nezhodujú nižšie",
                        services: "Menu nie je k dispozícii, vaše požiadavky na objednávku sa nezhodujú nižšie",
                        hours: 'Menu je nedostupné, vaša objednávka nie je v rámci tohto menu',
                        pre_order: "Menu nie je k dispozícii, vaša objednávka nezodpovedá požiadavkám na predobjednávku",
                        age: 'Menu nie je k dispozícii, ak si chcete objednať z tohto menu, musíte byť prihlásený s účtom overeným vekom',
                    },
                    services: {
                        title: 'Požiadavky na objednávku',
                        pickup: 'Odbery',
                        delivery: 'Doručenie',
                        dine_in: 'Konzumácia na mieste',
                    },
                    times: {
                        now: 'Žiadne predobjednávky',
                        later: 'Len predobjednávky',
                    },
                    hours: {
                        title: 'Dostupné hodiny',
                    },
                    preorder: {
                        title: 'Požiadavky na predobjednávku',
                        days_in_advance: 'Musíte objednať {{days}} dní vopred',
                        cutoff_time: 'Posledný deň uzávierky o {{time, timeFromTime}}',
                    },
                    age_restricted: {
                        title: 'Vekovo obmedzené',
                        approved: 'Váš účet je overený a môžete si objednať z tohto menu',
                        rejected: 'Na objednávku je potrebné overenie veku. Vytvorte si účet a nahrajte svoje ID',
                    },
                },
                search: {
                    title: 'Preskúmajte položky ponuky',
                    no_result: 'Nič sa nevrátilo. Chcete skúsiť iný hľadaný výraz?',
                    placeholder: 'čo hľadáš?',
                },
            },
            category: {
                restrictions: 'Obmedzenia kategórie',
                not_available: 'Kategória nie je k dispozícii',
                unavailable: {
                    services: "Kategória nie je k dispozícii, vaše požiadavky na objednávku sa nezhodujú nižšie",
                    hours: "Kategória nie je k dispozícii, hodiny vašej objednávky nie sú v rámci dostupných hodín tejto kategórie",
                },
            },
            info: {
                location: {
                    title: 'Poloha',
                    view_map: 'Zobraziť mapu',
                    phone: 'Telefón',
                },
                hours: {
                    title: 'OTVÁRACIE HODINY',
                    title_special: 'Špeciálne otváracie hodiny',
                },
                services: {
                    title: 'Služby',
                    notes: 'Poznámky',
                    delivery: {
                        ranges: 'Rozsahy doručenia',
                        zones: 'Zóny doručenia',
                        view_zones: 'Zobraziť zóny na mape',
                        fee: 'Poplatok za doručenie',
                        fee_short: 'Poplatok',
                        fee_varies: 'Rôzne, zobrazené v košíku',
                        min_order: 'Minimálna objednávka',
                        min_order_short: 'Min. Obj.',
                        no_min_order: 'Žiadna minimálna objednávka',
                        free_amount: 'Bezplatná suma doručenia',
                    },
                },
            },
            contact: {
                title: 'Kontaktujte nás',
                name: 'Meno',
                email: 'E-mail',
                phone: 'Telefónne číslo',
                message: 'Zadajte svoju správu...',
                send: 'Odoslať správu',
                success: 'Vaša správa bola úspešne odoslaná',
                error: 'Vyskytol sa problém, skúste to znova alebo neskôr',
            },
            footer: {
                powered_by: 'Beží na',
                terms_and_conditions: 'Zmluvné podmienky',
                privacy: 'Zásady ochrany osobných údajov',
                cookie: 'Zásady používania súborov cookie',
            },
        },
        pages: {
            payment_completed: {
                title: 'Vaša platba bola spracovaná. Ďakujeme za vašu objednávku!',
                subtitle: 'Informácie o objednávke boli odoslané na vašu e-mailovú adresu.',
                back_to_menu: 'Späť do menu',
                close_tab: 'Zatvorte túto kartu',
            },
            payment_failed: {
                title: 'Bohužiaľ, pri spracovaní vašej platby sa vyskytla chyba.',
                subtitle: '',
                back_to_menu: 'Späť do menu',
                close_tab: 'Zatvorte túto kartu',
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'Potvrdenie o rezervácii',
            details: {
                datetime: 'Rezervácia pre',
                number_of_people: 'Počet osôb',
                placed: 'Vytvorené',
                updated: 'Posledná aktualizácia',
                notes: 'Poznámky',
                name: 'Meno',
                email: 'E-mail',
                phone: 'Telefón',
                store_address: 'Adresa prevádzky',
            },
            status_update: {
                title: 'Rezervácia {{number}} bola aktualizovaná',
                body: 'Stav vašej rezervácie bol aktualizovaný na {{status}}',
            },
            email_common: {
                name: 'Meno: {{name}}',
                phone: 'Telefón: {{number}}',
                number_of_people: 'Počet osôb: {{number}}',
                date: 'Dátum: {{date}}',
                time: 'Čas: {{time}}',
                location: 'Prevádzka: {{name}}',
                notes: 'Poznámky: {{name}}',
            },
            email_new_booking_restaurant: {
                subject: 'Rezervácia nového stola {{number}} od {{name}}',
                powered_by: 'Používa technológiu {{name}}',
                overview: 'Žiadosť o rezerváciu nového stola',
                title: 'Nová rezervácia pre {{name}}',
                subtitle: 'Číslo rezervácie {{number}}',
                description_confirmed: 'Rezervácia je automaticky potvrdená. Môžete ho zrušiť prostredníctvom administračného panela a váš zákazník bude informovaný e-mailom',
                description_unconfirmed: 'Prosím potvrďte alebo zrušte rezerváciu cez administračný panel',
                url_pre_text: 'Zobraziť a aktualizovať na',
            },
            email_new_booking_customer: {
                subject: 'Žiadosť o rezerváciu stola',
                powered_by: 'Používa technológiu {{name}}',
                overview: 'Žiadosť o rezerváciu nového stola',
                title: 'Ďakujeme za Vašu rezerváciu',
                subtitle: 'Číslo rezervácie {{number}}',
                description: '<b>Po potvrdení alebo odmietnutí rezervácie dostanete ďalší e-mail.</b><br> Ak chcete vykonať akékoľvek zmeny vo vašej rezervácii, kontaktujte nás. Podrobnosti o vašej rezervácii sú nasledovné:',
                url_pre_text: 'Potvrdenie o rezervácii v reálnom čase si môžete pozrieť na adrese',
            },
            email_update_booking_customer: {
                subject_confirmed: 'Rezervácia stola potvrdená',
                subject_unconfirmed: 'Rezervácia stola zrušená',
                powered_by: 'Používa technológiu {{name}}',
                overview: 'Žiadosť o rezerváciu stola',
                title_confirmed: 'Rezervácia potvrdená',
                title_unconfirmed: 'Rezervácia zrušená',
                subtitle: 'Číslo rezervácie {{number}}',
                description_confirmed: 'Tešíme sa na Vás. Ak chcete požiadať o akékoľvek zmeny vo vašej rezervácii, kontaktujte nás',
                description_unconfirmed: 'S ľútosťou vám oznamujeme, že vašu žiadosť o rezerváciu nebolo možné prijať. Ospravedlňujeme sa za spôsobené nepríjemnosti. Ak máte nejaké otázky, kontaktujte nás',
                url_pre_text: 'Potvrdenie o rezervácii v reálnom čase si môžete pozrieť na adrese',
            },
            email_status_update_customer: {
                subject: 'Rezervácia #{{number}} – {{subjectLabel}}',
                body: 'Vaša rezervácia #{{number}} v {{store}} je teraz {{status}}.',
            },
            errors: {},
            status_warning: 'Aktualizujte stav tejto rezervácie na svojom administračnom paneli na stránke rezervácií',
        },
    },
    email_delayed_order: {
        subject: 'Objednávka #{{number}} – {{subjectLabel}}',
        header: 'Aktualizovaný čas prípravy',
        title: 'Aktualizovaný čas prípravy',
        order_number: 'Číslo objednávky: {{number}}',
        description: 'Vaša objednávka bude teraz hotová o {{time}}.',
        order_time_updated_to: 'Čas vašej objednávky bol aktualizovaný.',
        powered_by: 'Používa technológiu {{name}}',
        button_text: 'Sledovať objednávku',
        subject_label: 'Aktualizovaný čas prípravy',
        subject_label_delivery: 'Aktualizovaný čas doručenia',
        body_ready: 'Vaša objednávka bude teraz hotová o {{time}}.',
        body_delivery: 'Vaša objednávka bude teraz doručená o {{time}}.',
    },
    order: {
        receipt: {
            est_ready_time: 'Odhad. Čas pripravenosti',
            est_driver_pickup_time: 'Odhad. Čas vyzdvihnutia vodiča',
            est_delivery_time: 'Odhad. čas doručenia',
            tab_details: 'Podrobnosti',
            tab_dishes: 'Položky',
            future_order: 'Budúca objednávka',
            reprint: 'ZNOVU VYTLAČIŤ',
            details: {
                order_no: 'Objednávka č.',
                status: 'Stav',
                placed: 'Zadané',
                due: 'Termín',
                due_asap: 'Teraz / ASAP',
                last_updated: 'Posledná aktualizácia',
                total: 'Celkom',
                type: 'Typ',
                origin: 'Pôvod',
                table: 'Stôl',
                number_of_people: 'Počet ľudí',
                payment_method: 'Spôsob platby',
                payment_status: 'Stav platby',
                payment_currency: 'Platobná mena',
                notes: 'Poznámky',
                name: 'Meno',
                email: 'E-mail',
                phone: 'Telefón',
                distance: 'Vzdialenosť',
                driving_time: 'Čas jazdy',
                delivery_zone: 'Zóna',
                delivery_address: 'Dodacia adresa',
                delivery_provider: 'Poskytovateľ doručenia',
                delivery_tracking: 'Sledovanie doručenia',
                delivery_return_tracking: 'Sledovať návrat',
                delivery_tracking_link: 'Sledovať objednávku',
                tookan_status: 'Stav Tookan',
                tookan_status_failed_book: 'Rezervácia doručenia zlyhala',
                tookan_status_failed_update: 'Rezerváciu sa nepodarilo aktualizovať',
                tookan_status_success: 'Rezervované na doručenie',
                store_address: 'Adresa prevádzky',
                destination: 'Cieľ',
                estimated_arrival_time: 'Odhadovaný čas príchodu',
                delivery_status: 'Stav',
                delivery_track_your_order: 'Sledujte svoju objednávku',
                delivery_text: 'Doručenie',
                arrival_date: 'Dátum príchodu',
            },
            dishes: {
                headings: {
                    quantity: 'Množstvo',
                    item: 'Položka',
                    price: 'Cena',
                },
                notes: 'Poznámky',
                remove_ingredients: 'Odstrániť prísady',
            },
            status_update: {
                title: 'Objednávka {{number}} bola aktualizovaná',
                body: 'Stav vašej objednávky bol aktualizovaný na {{status}}',
            },
            wait_time_update: {
                title: 'Objednávka {{number}} bola aktualizovaná',
                body: 'Termín dokončenia vašej objednávky bol aktualizovaný',
            },
            delivery_update: {
                title: 'Objednávka {{number}} bola aktualizovaná',
                body: 'Vaša objednávka bola zarezervovaná na doručenie. Pozrite si odkaz na sledovanie v reálnom čase',
            },
            payment_status_update: {
                title: 'Objednávka {{number}} bola aktualizovaná',
                body: 'Stav platby vašej objednávky bol aktualizovaný.',
            },
            email_new_order_restaurant: {
                subject: 'Nová objednávka ({{number}}) - {{name}}',
                powered_by: 'Používa technológiu {{name}}',
                overview: 'Oznámenie o novej objednávke',
                title: 'Nová objednávka zadaná v {{name}}',
                subtitle: 'Číslo objednávky {{number}}',
                description: 'Pozrite si podrobnosti a aktualizácie prostredníctvom hlavného panela správcu',
                button_text: 'Sledovať objednávku',
                track_delivery_button_text: 'Sledovať doručenie',
            },
            email_new_order_customer: {
                subject: 'Potvrdenie objednávky ({{number}})',
                powered_by: 'Používa technológiu {{name}}',
                overview: 'Oznámenie o novej objednávke',
                title: 'Nová objednávka zadaná v {{name}}',
                subtitle: 'Číslo objednávky {{number}}',
                description: 'Pozrite si podrobnosti a aktualizácie prostredníctvom online potvrdenia v reálnom čase',
                button_text: 'Sledovať objednávku',
                track_delivery_button_text: 'Sledovať doručenie',
            },
            email_order_completed_by_customer: {
                subject: 'Objednávka ({{number}}) dokončená zákazníkom',
                powered_by: 'Používa technológiu {{name}}',
                overview: 'Oznámenie o dokončení objednávky',
                title: 'Objednávka dokončená v {{name}}',
                subtitle: 'Číslo objednávky {{number}}',
                description: 'Zobrazte podrobnosti a aktualizujte svoju objednávku prostredníctvom hlavného panela alebo pomocou potvrdenia na adrese',
            },
        },
        totals: {
            tax: '{{name}} ({{percent}} %)',
            tax_in_prices: '{{name}} ({{percent}}%) zahrnuté v cene',
            fee: '{{name}} ({{value, currency}} + {{percent}}%)',
            fee_percent: '{{name}} ({{percent}} %)',
            fee_fixed: '{{name}}',
            delivery_fee: 'Poplatok za doručenie',
            delivery_fee_offset: 'Zľava z poplatku za doručenie',
            delivery_fee_total: 'Poplatok za doručenie celkom',
            promo: 'Zľava: {{name}} ({{value, currency}} + {{percent}}% zľava)',
            promo_percent: 'Zľava: {{name}} ({{percent}}%)',
            promo_fixed: 'Zľava: {{name}}',
            promo_none: 'Zľava: {{name}}',
            cart: 'Košík',
            tip: 'Prepitné',
            total: 'Celkom',
        },
        status: {
            unconfirmed: 'Nepotvrdené',
            awaiting_payment: 'Čaká sa na platbu',
            confirmed: 'Potvrdené',
            ready: 'Pripravené',
            on_route: 'Na trase',
            complete: 'Dokončené',
            cancelled: 'Zrušené',
            seated: 'Usadení',
        },
        searching: {
            lalamove_search_placeholder: 'Vyhľadajte objednávku podľa ID doručenia Lalamove',
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: 'Nedostupné',
                },
            },
            dish: {
                no_stock: 'Vypredané',
                not_available: 'Nie je k dispozícii',
            },
        },
    },
    admin: {
        registration: {
            register_confirmation_code_subject: 'E-mailový potvrdzovací kód',
            register_confirmation_code_email: 'Váš potvrdzovací kód e-mailu je {{confirmation_code}} (platnosť vyprší o 24 hodín)',
            register_confirmation_code_email_onbehalf: 'Váš potvrdzovací kód e-mailu je {{confirmation_code}} (platnosť vyprší o 24 hodín). Toto je pre e-mailovú adresu {{email}}.',
        },
    },
};
//# sourceMappingURL=sk.js.map